/**
 * instrument api
 */
import httpRequest from "@/utils/request";

export default {};
